"use strict";

var TrashConditionCertaintyEsriDynamicMapLayer = function () {
  const esriKey = "trash";
  const esriLayer = "trashConditionCertainty";
  const layerName = "trashConditionCertaintyEsriDynamicMap";
  const layerKey = "trashConditionCertaintyEsriDynamicMapLayer";

  var loadLayerListenersForMap = function (map, mapLayers, mapId) {
    var layer = new EsriDynamicMapLayer(layerName, layerKey, esriKey, esriLayer);
    layer.loadToggledListenerForMap(map, mapLayers, mapId);
    layer.loadFiltersUpdatedListenerForMap(map, mapLayers, mapId);
  };

  return {
    loadLayerListenersForMap,
  };
};

module.exports = TrashConditionCertaintyEsriDynamicMapLayer();

const EsriDynamicMapLayer = require("../mapFunctions/esriDynamicMapLayer");
